import { Colors } from "src/com/sixdee/crbtportal/utils/resources/colors";
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from "../../../../toolkit/uicomponentcss";

export interface FlashMessageCardCSSStyle extends UIComponentCSSStyle
{
    getToneWrapperCSSStyle(onHover:boolean): object;
    getImgCSSStyle(): object;
    getOnHoverCSSStyle(): object;
    getMobileToneWrapperCSSStyle(): object;
    getMobileImgCSSStyle(): object;
    getMobileOnHoverCSSStyle(): object;
   
}

export class FlashMessageCardCSSStyleImpl extends UIComponentCSSStyleImpl implements FlashMessageCardCSSStyle
{
    getToneWrapperCSSStyle(onHover:boolean): object
    {
        return {
            // height: '340px', 
            // width: '262px', 
            // marginRight: "40px",
            // marginTop: marginTop,
            objectFit: 'cover', 
            position: 'relative',
            cursor: "pointer",
            borderRadius:'0px 50px 0px 50px',
            background: "transparent url('img/Screenshot 2023-11-22 at 6.47.29 PM.png') 0% 0% no-repeat padding-box",
            boxShadow:"5px 5px 5px 5px  #F4F4F4",
            paddingLeft:"20px",
            paddingRight:"20px"

        };
    }

    getOnHoverCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            position: 'absolute',
            // height: '280px', 
            // width: '262px', 
            // borderRadius:'50px 0px 50px 0px',
            display: "inline",
            // paddingLeft: "20px",
            // paddingRight: "20px",
            // paddingTop: "20px",
            background:"#FFC400",
            borderRadius:'0px 50px 0px 50px',
            left:"-2px"
        };
    }

    getImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            width: '100%', 
            height: '280px',
            borderRadius: "50px 0px 50px 0px",
        };
    }

    getDetailsDivCssStyle(): object 
    {
        return {
            objectFit: 'cover', 
            // height: '60px',
            display: "flex",
            position: "relative",
            flexDirection: "row",
            flexFlow: "row wrap",
            backgroundColor: this.getResources().getColor(Colors.color_5)
        };
    }
    getMobileToneWrapperCSSStyle(): object
    {
        return {
            height: '140px', 
            width: '131px', 
            marginTop: "70px",
            objectFit: 'cover', 
            position: 'relative',
            cursor: "pointer",
            borderRadius:'25px 0px 25px 0px',
            background: "#FFFFFF 0% 0% no-repeat padding-box",
            border: "1px solid #F4F4F4"
        };
    }

    getMobileOnHoverCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            position: 'absolute',
            height: '140px', 
            width: '131px', 
            borderRadius:'25px 0px 25px 0px',
            display: "flex",
            paddingLeft: "10px",
            paddingRight: "10px",
            paddingTop: "20px",
            background:"#FFC400"

        };
    }

    getMobileImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            width: '100%', 
            height: '140px',
            borderRadius: "25px 0px 25px 0px",
        };
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/flashmessagecard/flashmessagecardcss.tsx